import "core-js/modules/es.function.name";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _classCallCheck from "@babel/runtime-corejs3/helpers/esm/classCallCheck";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * The draft application and its list of programs data model.
 *
 * @export
 * @class DraftApplicationsModel
 */

var model =
/**
 * Creates an instance of DraftApplicationsModel.
 *
 * @param {any} json The json input containing a list of messages in a json format.
 * @memberof DraftApplicationsModel
 */
function model(json) {
  var _context;

  _classCallCheck(this, model);

  this.draft_application_id = json.draft_application_id;
  this.name = json.name;
  this.createdOn = new Date(json.createdOn);
  this.lastUpdatedOn = new Date(json.lastUpdatedOn);
  this.isSubmissionForm = json.isSubmissionForm;
  this.programs = _mapInstanceProperty(_context = json.programs).call(_context, function (programJson) {
    return {
      application_program_id: programJson.programId,
      name: programJson.name
    };
  });
};

export { model as default };